"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.osUrls = void 0;
var platformUrlCollection = {
    launcher: {
        MacOS: 'https://webcontent.attensi.com/download/attensi-launcher.pkg',
        Windows: 'https://webcontent.attensi.com/download/attensi-launcher.msi',
    },
};
var getUrl = function (platformLink, os) {
    var link = platformUrlCollection[platformLink];
    if (!link) {
        return null;
    }
    return link[os] || null;
};
exports.osUrls = {
    launcher: function (os) { return getUrl('launcher', os); },
};
//# sourceMappingURL=osUrls.js.map